<div *ngIf="informantForm">
    <div *ngIf="questionIndex === 0">
        <div [formGroup]="informantForm" class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-9">
                    <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
                        ngDefaultControl (change)="setQuestionInformant(informantForm.value)" (change)="copyArr()">
                    <span *ngIf="informantForm.value.media?.file_name">
                        <span style="display: inline;">
                            {{ informantForm.value.media.file_name }}
                        </span>
                        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(informantForm)">
                            <span class="text-danger">✖</span>
                        </button>
                    </span>
                    <!-- <span *ngIf="informantForm.value.media?.file_name">{{ informantForm.value.media.file_name }}</span> -->
                </div>
                <div class="col-1">
                    <button mat-mini-fab class="img" (click)="fileInput.click()"
                        style="border-radius: 0; box-shadow: none;"
                        [style.backgroundImage]="'url(\' ../../../../assets/multimedia.png\')'">
                        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
                            (change)="addQuestionMedia($event, informantForm)" style="display:none;" />
                    </button>
                </div>
            </div>
            <div *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
                class="form-group row" formGroupName="media">
                <label
                    class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
                <div class="col-2">
                    <input [attr.disabled]="informantForm.value.media.unlimit ? true : null" class="form-control"
                        formControlName="time_again" type="number" min="0" width="100px"
                        (change)="setTimeAgain(informantForm, $event)" (change)="copyArr()">
                </div>
                <div class="col">
                    <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
                        (change)="clearValueDate(informantForm, informantForm.value.media.unlimit)"
                        (change)="copyArr()">
                        ไม่จำกัดรอบ</mat-checkbox>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-2 col-form-label">ชื่อ Most<lifedi-require></lifedi-require></label>
                <div class="col-4">
                    <input type="text" class="form-control" id="most" formControlName="most" autocomplete="off"
                        (change)="setQuestionInformant(informantForm.value)" ngDefaultControl (change)="copyArr()">
                </div>
                <label class="col-2 col-form-label">ชื่อ Least<lifedi-require></lifedi-require></label>
                <div class="col-4">
                    <input type="text" class="form-control" id="least" formControlName="least" autocomplete="off"
                        (change)="setQuestionInformant(informantForm.value)" ngDefaultControl (change)="copyArr()">
                </div>
            </div>

            <div *ngFor="let c of informantFormArray.controls; let i = index" formArrayName="choices">
                <div [formGroupName]="i" class="form-group row">
                    <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
                    <input class="form-control col-10" formControlName="choice_detail" (change)="copyArr()"
                        (change)="setChoiceInformant(c.value.choice_detail, i)" type="text">
                    <button mat-mini-fab class="img col-1" (click)="deleteChoice(informantFormArray, i)"
                        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
                    </button>
                    <div class="offset-1 col-11">{{ c.value.choiceImg }}</div>
                </div>
            </div>

            <button mat-mini-fab class="img col-1" (click)="addChoice(informantFormArray)"
                [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
            </button>
        </div>
    </div>

    <div *ngIf="questionIndex !== 0">
        <div class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-9">
                    <input type="text" class="form-control" id="question" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].question" autocomplete="off" ngDefaultControl>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label">ชื่อ Most<lifedi-require></lifedi-require></label>
                <div class="col-4">
                    <input type="text" class="form-control" id="most" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].most" autocomplete="off" ngDefaultControl>
                </div>
                <label class="col-2 col-form-label">ชื่อ Least<lifedi-require></lifedi-require></label>
                <div class="col-4">
                    <input type="text" class="form-control" id="least" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].least" autocomplete="off" ngDefaultControl>
                </div>
            </div>

            <div *ngFor="let c of informantArray[questionIndex - 1].choices; let i = index">
                <div class="form-group row">
                    <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
                    <input class="form-control col-10" [(ngModel)]="c.choice_detail" (change)="copyArr()" type="text">
                </div>
            </div>
        </div>
    </div>
</div>